import {NotiService} from "./noti.service";

export const NotiInjectables: Array<any> = [
  {
    provide: NotiService,
    useClass: NotiService,
  },
];
